import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddProject } from '../../../add-project'

export const ProjectPopUp = () => {
  const { menuTarget, open, onCloseMenu } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.project && open} target={menuTarget?.target}>
      <AddProject onCloseMenu={onCloseMenu} />
    </PopUpContainer>
  )
}
